import { ContactDTO } from 'new-beginning/queries';

export const isContactPurchased = (contact: ContactDTO) => {
	if (!contact.hasEmail && !contact.hasPhone) return false;
	return !!contact.email || !!contact.phone;
};
